import { memo } from 'react';
import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';
import AsideNavContent from '#/modules/infra/layout/AsideNavContent';

/**
 * Admin 左側導覽桌面 rail 殼。
 * 僅由 AdminLayout 在 isDesktop 時掛載；選單本體見 AsideNavContent。
 */
const Aside = ({ toggleExpanded }) => (
  <aside className={cn('aside', toggleExpanded && 'expanded')}>
    <AsideNavContent />
  </aside>
);

Aside.propTypes = {
  toggleExpanded: PropTypes.bool.isRequired,
};

export default memo(Aside);
